// extracted by mini-css-extract-plugin
export default {"footer":"layout-footer_footer__EbxpN","footerCondition":"layout-footer_footerCondition__xPENJ"};